import {Component, Inject, Optional} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {

  title = '';
  description = '';
  buttonCancel = '';
  buttonOk = '';
  additionalActions: {title: string, result: string}[];
  buttonCancelHidden = false;
  buttonOkHidden = false;

  constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent>,
              private translateService: TranslateService,
              @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.dialogRef.addPanelClass('xs-popup-confirm');
    this.title = data && data.title || this.translateService.instant('general.api_confirm_dialog_title');
    this.description = data && data.description || this.translateService.instant('general.api_confirm_dialog_description');
    this.buttonCancel = data && data.buttonCancel || this.translateService.instant('general.api_general_cancel');
    this.buttonOk = data && data.buttonOk || this.translateService.instant('general.api_general_ok');
    this.additionalActions = data && data.additionalActions;
    this.buttonCancelHidden = data && data.buttonCancelHidden;
    this.buttonOkHidden = data && data.buttonOkHidden;
  }

  close(result?: string) {
    this.dialogRef.close(result ?? true);
  }
}
